const trainingTypes = [
  // { label: "Badminton", value: "1" },
  { label: "Ball Sports Training", value: "2" },
  // { label: "Bike", value: "3" },
  // { label: "Brisk walking", value: "4" },
  { label: "Cardio", value: "5" },
  { label: "Flexibility and Stretching", value: "6" },
  // { label: "Fun Activity", value: "7" },
  { label: "Functional Training", value: "8" },
  { label: "High-Intensity Interval Training (HIIT)", value: "9" },
  // { label: "Just for Fun", value: "10" },
  { label: "Skill Training", value: "11" },
  // { label: "Softball", value: "12" },
  { label: "Strength Training", value: "13" },
  // { label: "Walking", value: "14" },
];

export default trainingTypes;